import { Component, Inject, InjectionToken, Input, Optional } from "@angular/core"

// écran qui sait tout enregistrer (ex. Modifier une pièce) : la pastille propose alors une disquette
export interface UnsavedSaver {
  saving: boolean
  saveAll(): void
}
export const UNSAVED_SAVER = new InjectionToken<UnsavedSaver>("UNSAVED_SAVER")

// pastille rouge signalant des modifications non enregistrées
@Component({
  selector: "app-unsaved-dot",
  templateUrl: "./unsaved-dot.component.html",
  styleUrls: ["./unsaved-dot.component.scss"],
})
export class UnsavedDotComponent {
  @Input() show = false

  constructor(@Optional() @Inject(UNSAVED_SAVER) public saver: UnsavedSaver | null) {}

  save(event: Event): void {
    event.stopPropagation()
    this.saver?.saveAll()
  }
}
